import React from 'react';

interface UseChatPollingProps {
  onPoll: () => void;
  enabled: boolean;
  interval?: number;
}

export const usePolling = ({ onPoll, enabled, interval = 5000 }: UseChatPollingProps) => {
  const intervalRef = React.useRef<NodeJS.Timeout | null>(null);
  const onPollRef = React.useRef(onPoll);

  // Actualizar la referencia sin recrear el effect
  React.useEffect(() => {
    onPollRef.current = onPoll;
  }, [onPoll]);

  React.useEffect(() => {
    if (enabled) {
      intervalRef.current = setInterval(() => {
        onPollRef.current();
      }, interval);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [enabled, interval]);

  return {
    isPolling: enabled && intervalRef.current !== null
  };
};
